import { useDispatch } from "react-redux";
// import { message } from "antd";

import * as REDUX_ACTION from "../../../../../v1/services/redux/actions";

// const dispatch = useDispatch();

export const handleMark = (record, action, dispatch, messageApi, user) => {
  // const [messageApi, contextHolder] = message.useMessage();

  let updatedStatus;
  if (action === "active" && (record.status === 2 || record.status === 0)) {
    updatedStatus = 1;
  } else if (
    action === "suspended" &&
    (record.status === 1 || record.status === 0)
  ) {
    updatedStatus = 2;
  } else if (
    action === "terminated" &&
    (record.status === 1 || record.status === 2)
  ) {
    updatedStatus = 0;
  } else {
    console.error("Invalid action or status 1");
    return;
  }

  if (updatedStatus !== undefined) {
    const updatedItems = { ...record, status: updatedStatus }
    
    delete updatedItems.key;
    delete updatedItems.company_name;

    const updatedRecord = {
      uid: record.uid,
      updatedBy: user?.memid,
      items: updatedItems,
    };

    messageApi.open({
      type: "loading",
      content: "Updating Status...",
      duration: 0,
    });

    dispatch(
      REDUX_ACTION.v1_employer.update_employer_request(updatedRecord, () => {
        messageApi.destroy();
      })
    );
  } else {
    console.error("Invalid action or status 2");
  }
};
